<template>
  <div id="app">
    <div v-if="!ie">
      <div class="page">
        <Navigation />
        <router-view />
      </div>
      <Footer />
    </div>
    <div v-if="ie" style="text-align: center; padding: 60px;">
      <p>We're sorry but this website does not currently work on Internet Explorer. Please use another browser.</p>
    </div>
  </div>
</template>

<script>
const Bowser = require("bowser");
const currentBrowser = Bowser.getParser(window.navigator.userAgent);

import Navigation from '@/components/layout/Navigation.vue'
import Footer from '@/components/layout/Footer.vue'

export default {
  name: 'App',
  components: {
    Navigation,
    Footer
  },
  data: () => ({
    browser: "",
    ie: "",
  }),
  created: function () {
    this.browser = currentBrowser.getBrowserName()
    if(this.browser === "Internet Explorer"){
      this.ie = "true"
    } else {
      this.ie = ""
    }
  },
}
</script>

<style lang="scss">
@import "@/assets/sass/_static/_static.scss";
@import "@/assets/sass/_fonts/_fonts.scss";

@media (max-width: 1350px){
  .page{
    width: 80%;
  }
}
@media (max-width: 1200px){
  .page{
    width: 90%;
  }
}

@media (min-width: 768px){
  #app{
    padding-bottom: 30px;
  }
}
</style>
